import {AppStorageState} from '../interfaces/appState.interface';

export const initialState : AppStorageState = {
    config : null,

    poll : null,
    pollExtraFields : null,
    scriptQuestSets : null,
    scripts: null,
    questions : null,

    polls : null,
    lastPollListLink: null
};
